import { forwardRef, PropsWithChildren } from 'react'

import { AvatarProps } from '@mui/material'
import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'

import { UserAvatar } from './UserAvatar'

type CurrentUserAvatarProps = { size?: number } & PropsWithChildren<AvatarProps>

export const CurrentUserAvatar = forwardRef<HTMLDivElement, CurrentUserAvatarProps>(
  ({ size = 40, children, ...props }, ref) => {
    const platform = useAuthStore((state) => state.platform)
    const user = useAuthStore((state) => state.user)

    return (
      <UserAvatar
        ref={ref}
        size={size}
        name={platform === PLATFORM.DDE ? undefined : user?.name}
        {...props}
      >
        {children}
      </UserAvatar>
    )
  }
)

CurrentUserAvatar.displayName = 'CurrentUserAvatar'
